import { Skeleton, Stack } from '@chakra-ui/react'
import React from 'react'

const TableLoading = () => {
    return (
        <Stack w='100%' position='absolute' mt='30px' h='30vh' spacing={4}>
            <Skeleton height='30px' />
            <Skeleton height='30px' />
            <Skeleton height='30px' />
            <Skeleton height='30px' />
            <Skeleton height='30px' />
            <Skeleton height='30px' />

        </Stack>
    )
}

export default TableLoading